import { CollectionEntity } from "@busy-human/gearbox";
import { CONSTANTS } from "../constants.js";
export var Leads;
(function (Leads) {
    ;
    function Defaults() {
        const [dateNow] = new Date().toISOString().split('T');
        // const dateNow = Date.now().toString();
        return {
            _id: "",
            createdTimestamp: dateNow,
            lastContact: dateNow,
            name: {
                firstName: "",
                lastName: "",
                fullName: "",
            },
            email: "",
            phone: "",
            dogInfo: "",
            notes: "",
            postalCode: "",
            formMessage: "",
            formHow: "",
            newsLetter: false,
            leadOrigin: CONSTANTS.LEAD_ORIGIN.Other,
            productInterest: CONSTANTS.PRODUCT_INTEREST.Other,
            discountQualifier: CONSTANTS.DISCOUNT_QUALIFIER.None,
            status: CONSTANTS.STATUS.New,
        };
    }
    Leads.Defaults = Defaults;
    ;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Defaults();
        }
    }
    Leads.CollectionClass = CollectionClass;
    ;
    Leads.Collection = new CollectionClass({ path: '/Leads' });
})(Leads || (Leads = {}));
;
//# sourceMappingURL=index.js.map